import styled from 'styled-components';

const SelectTicketHeader = styled.div`
  font-size: 1.4rem;
  font-weight: 300;
  margin-right: 0.625vw;
  line-height: 1.2;
  // margin-top: 3px;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 5px;
  border: 2px solid #102027;
  border-radius: 10px;
  background: ${props => (props.$active ? '#102027' : 'transparent')};
  color: ${props => (props.$active ? '#fff' : '#102027')};
  padding: 1.5% 3%;
  font-variant-caps: all-small-caps;
`;

export default SelectTicketHeader;
